import store from "../index.js"

const state = {
	userInfo: '',
}
const mutations = {
	updateUserInfo: function(state,payLoad) {
		state.userInfo = payLoad;
	},
}
const actions = {
	async updateUserInfo(context) {
		context.commit('updateUserInfo',res)
	}
}
export default {
	state,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js